import InventoryList from './InventoryList'

export default { list: InventoryList }
